export default function (Component) {
Component.options.__title = "Panel Grid (5 Colunns)"
}